$(function() {

    var toggleButton = $('.js-nav-toggle');
    var menuBar = $('.js-menu-bar');

    toggleButton.on('click', function (e)
    {
        // e.stopPropagation();
        // e.preventDefault();

        var $target = $('#' + $(this).data('target'));

        if ($target && $target.length > 0)
        {
            if (toggleButton.hasClass('menu-button--is-inactive'))
            {
                toggleButton.removeClass('menu-button--is-inactive').addClass('menu-button--is-active');
                menuBar.addClass('menu-wrapper--is-active');
                $target.slideDown();
            }
            else
            {
                toggleButton.removeClass('menu-button--is-active').addClass('menu-button--is-inactive');
                menuBar.removeClass('menu-wrapper--is-active');
                $target.slideUp();
            }
        }
    });

    // Submenu toggle
    $('.js-subnav-toggle').on('click', function () {
        $(this).siblings('.sub-menu').slideToggle();
        $(this).toggleClass('sub-menu-toggle--is-active');
    });

    $('.js-level2-nav-toggle').on('click', function () {
        var $target = $('#' + $(this).data('target'));
        $target.slideToggle();
        $(this).toggleClass('secondary-menu__button--is-active');
    });



    $(window).scroll(function() {
        var scroll = $(window).scrollTop();

        if (scroll >= 150) {
            menuBar.addClass("menu-wrapper--is-scrolled");
        } else {
            menuBar.removeClass("menu-wrapper--is-scrolled");
        }
    });

});

